import { Query } from "../Model/Query";
export class AnswersService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    getInstanceAnswers(instanceId) {
        const query = new Query(0, 1000);
        query.addFilter('id_instance', [instanceId]);
        return this.queryAnswers(query);
    }
    async queryAnswers(query) {
        const params = this.queryParamsFactory.createQueryParams(query);
        const response = await this.apiService.get(`answers?${params}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener las respuestas.');
        }
        return response.json();
    }
    async saveAnswer(answer) {
        const response = await this.apiService.post('answer', answer);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar la respuesta.');
        }
    }
}
